import { Badge } from './Badge'
import { useGetPersonalShopperItemsCount } from '../../customer/getCustomer.query'

export const ShopperBoxesCount = () => {
    const { loading, numItems } = useGetPersonalShopperItemsCount()
    return loading || !numItems ? null : <Badge>{numItems}</Badge>
}
